export const RESET_PASSWORD_DIALOG_TITLE = 'reset-password-dialog.title';
export const RESET_PASSWORD_DIALOG_BUTTON_TEXT = 'reset-password-dialog.button-text';
export const RESET_PASSWORD_DIALOG_ICON_ALT = 'reset-password-dialog.icon-alt';
